module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "to"
  }, [_c('b', [_vm._v("T")]), _c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE OF")])]), _vm._v(" "), _c('b', [_vm._v("C")]), _c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c2_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c3_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c8_r1"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c9_r1"
    }
  }, [_c('b', [_vm._v("PART I: COUNTRY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c10_r1"
    }
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISA")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLEN")]), _vm._v("-A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GOSTINI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Sans Souci")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Pot Luck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c11_r1"
    }
  }, [_c('b', [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVIN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALDEOSINGH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Couva")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("The Rape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANI")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOTOO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("San Fernando")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("The Funeral Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EENA")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDREA")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANICKCHAND")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Caroni Swamp")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Dougla")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMABAI")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SPINET")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Santa Cruz")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Nowarian Blues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLI")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Godineau")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Betrayal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AIME")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Palmiste")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Bury Your Mother")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONYA")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMPADOO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Maracas")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Standing on Thin Skin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c9_r1"
    }
  }, [_c('b', [_vm._v("PART II: TOWN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ELISHA EFUA BARTELS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Diego Martin")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Woman Is Boss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AWRENCE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("COTT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Maraval")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Prophet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTONI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Uptown Port-of-Spain")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("How to Make Photocopies in the Trinidad & Tobago National Archives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARBY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALONEY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("San Juan")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("The Best Laid Plans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EITH")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARDIM")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Emperor Valley Zoo")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("The Jaguar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IAN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARIE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XTAVOUR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Tunapuna")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Eric’s Turn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIZABETH")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNEZ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("St. James")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Lucille")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHNI")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APILDEO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Fort George")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Peacock Blue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDITH")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("East Dry River")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Dark Nights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IPHANIE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANIQUE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Chaguaramas")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Gita Pinky Manachandi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Alle_9781617750601_epub_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("About the Contributors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c7d9134","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Alle_9781617750601_epub_c7_r1.vue
// module id = 75
// module chunks = 0